import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AlertSeverityTypeEnum, AlertTypeEnum } from '@shared/enums';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';

@Component({
    selector: 'app-alert',
    standalone: true,
    imports: [MessagesModule, TranslateModule, ButtonModule, NgClass],
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
    @Input({ required: true }) id!: string;
    @Input({ required: true }) alertType!: AlertTypeEnum;
    @Input({ required: true }) alertSeverityType!: AlertSeverityTypeEnum;
    @Input({ required: false }) content: string = '';
    @Input({ required: false }) closable = false;
    @Output() closeEvent = new EventEmitter<void>();

    readonly alertSeverityTypes = AlertSeverityTypeEnum;
    readonly alertTypes = AlertTypeEnum;
}
